import React from "react";
import { Spin } from "antd";

const BlueButton = ({
  className = "",
  onClick,
  children,
  disabled = false,
  isLoading,
  large,
  long,
  ...props
}) => {
  return (
    <button
      /* eslint-disable no-template-curly-in-string*/
      className={`${className} cursor-pointer bg-tripplo-200 focus:outline-none text-white font-poppins rounded-lg px-16 py-2 hover:bg-blue-500 hover:text-tripplo-200`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {isLoading ? <Spin /> : children}
    </button>
  );
};
export default BlueButton;
